export default {
	chooseIndex:0,
	arrayLength:0
}